export default __webpack_public_path__ + "packages/visuals/tables/assets/icon-64.png";